export enum TipoCuenta {
    CCC = '0',
    IBAN = '1',
}
